import React, { useCallback } from 'react'

import { BiNotepad } from 'react-icons/bi'
import { useDispatch } from 'react-redux'
import Direcao from '../../assets/logos/direcao-square.png'
import history from '../../services/history'
import { changeRecentPath } from '../../store/modules/recentView/action'
import Progress from '../Progress'
import { Container, ProgressWrapper, ModuleWrapper, ImageContainer, FreemiumSpan } from './styles'

interface CourseProgressCardProps {
  percentage?: number
  name: string
  numberOfModules?: number
  numberOfinstallment?: number
  price?: number
  icon?: string
  courseId: string
  contentType?: string
  isFreemium?: boolean
}

const CourseProgressCard: React.FC<CourseProgressCardProps> = ({
  name,
  percentage,
  numberOfModules,
  price,
  numberOfinstallment,
  icon,
  courseId,
  isFreemium,
}) => {
  const dispatch = useDispatch()
  const handleClick = useCallback(async () => {
    dispatch(changeRecentPath(`/${window.location.href.split('/').pop()}`))
    if (!price && !numberOfinstallment) return history.push(`/course/${courseId}`)
  }, [courseId, dispatch, numberOfinstallment, price])

  const getDetails = ({ percentage }) => {
    return (
      <ProgressWrapper>
        <span>Progresso no curso</span>
        <Progress percentage={percentage} page="cardCourse" />
      </ProgressWrapper>
    )
  }

  return (
    <Container title={name} onClick={handleClick} className="slorderIderStyle">
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <ImageContainer>
          <img src={icon ? icon : Direcao} alt={name} />
          {percentage === 100 && <span>Concluído</span>}
        </ImageContainer>
        {isFreemium ? (
          <div style={{ padding: '1rem', display: 'flex' }}>
            <FreemiumSpan>
              {numberOfModules} aula{`${numberOfModules > 1 ? 's' : ''}`} gratuita
              {`${numberOfModules > 1 ? 's' : ''}`}!
            </FreemiumSpan>
          </div>
        ) : (
          ''
        )}
      </div>
      <h2>{name?.length > 115 ? name?.substring(0, 115) + '...' : name}</h2>
      <ModuleWrapper>
        {price && numberOfinstallment && (
          <span>
            {numberOfinstallment}x de <b>{Number(price.toFixed(2)).toLocaleString('pt-BR')}</b>
          </span>
        )}
        {numberOfModules ? <BiNotepad /> : ''}
        {numberOfModules ? (
          <span>
            {numberOfModules} módulo{`${numberOfModules > 1 ? 's' : ''}`}
          </span>
        ) : (
          ''
        )}
      </ModuleWrapper>
      {getDetails({ percentage })}
    </Container>
  )
}

export default CourseProgressCard
